import { centsToDollars, dollarsToCents } from "helpers/price";
import { DirectPayLinkStatus, IDirectPayLink } from "types/DirectPayLink.d";

export const getDirectPayLinkStatus = (
  link: IDirectPayLink
): DirectPayLinkStatus => {
  if (!link.isActive) {
    return DirectPayLinkStatus.DEACTIVATED;
  }

  const now = new Date();
  const expiredByDate =
    link.expiresAt != null && now > new Date(link.expiresAt);

  if (expiredByDate || link.ordersCreated >= link.maxOrders) {
    return DirectPayLinkStatus.EXPIRED;
  }

  return DirectPayLinkStatus.ACTIVE;
};

export const getStatusColor = (status: DirectPayLinkStatus): string => {
  switch (status) {
    case DirectPayLinkStatus.ACTIVE:
      return "success";
    case DirectPayLinkStatus.EXPIRED:
      return "danger";
    case DirectPayLinkStatus.DEACTIVATED:
      return "warning";
    default:
      return "info";
  }
};

export const getOrdersCreatedPercentage = (
  ordersCreated: number,
  maxOrders: number
): number => {
  return (ordersCreated / maxOrders) * 100;
};

export const getOrdersProgressColor = (percentage: number): string => {
  if (percentage < 80) return "#22c55e"; // green
  if (percentage < 95) return "#eab308"; // yellow
  return "#ef4444"; // red
};

export const formatShortLink = (shortId: string): string => {
  return `${window.location.origin}/dp/${shortId}`;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      document.body.removeChild(textArea);
      return true;
    } catch (error) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};
